import { connect } from 'react-redux';
import { Message } from '../components/Common/Message';
import {
  getAlert,
  dismissAlert,
} from '../state/alerts';

const mapStateToProps = state => {
  return {
    current: getAlert(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDismiss: id => dispatch(dismissAlert(id)),
  };
};

export const AlertContainer = connect(mapStateToProps, mapDispatchToProps)(Message);
